import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { renderIconPostfixFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/generate-icon-postfix.js'

export function generateIconPostfix(field: SchemaField, indent: string): string {
  const label = field.label || field.name
  return renderIconPostfixFormFieldTemplate({
    indent: indent,
    fieldName: field.name,
    formLabel: formLabel(field, `${label} Icon`)
  })
}
